import { injectable } from 'inversify';
import { useAppSelector } from '../../state/hooks';
import { UserRepository } from '../../state/reduxRepositories';
import {
  CreateUserInput,
  UpdateUserInput,
  User,
} from '../../state/reduxRepositories/users/users.interfaces';

@injectable()
export class UserDomainService {
  public constructor(private userRepository: UserRepository) {}

  useUserErrorSelector = () => {
    return useAppSelector(this.userRepository.selectors.errorsSelector);
  };

  useUserResourceSelector = () => {
    return useAppSelector(this.userRepository.selectors.resourcesSelector);
  };

  useLoadingResourceSelector = () => {
    return useAppSelector(this.userRepository.selectors.isLoadingSelector);
  };

  dispatchClearError = (id: string) => {
    return this.userRepository.dispatchClearError(id);
  };

  dispatchUpdate = (userUpdateInput: UpdateUserInput) => {
    return this.userRepository.dispatchUpdate(userUpdateInput);
  };

  dispatchCreate = (userData: CreateUserInput) => {
    return this.userRepository.dispatchCreate(userData);
  };
}
